import React from 'react';
import {StrokeGradientText} from '../stroke-gradient-text/stroke-gradient-text';
import {CtaButton} from '../cta-button/cta-button';
import PinklightEffect from '../lights-effect/pink-light-effect';
import ArtistWithLightEffect from '../register-section/components/artist-with-light-effect';
import ArtistWithLightEffectV2 from '../register-section/components/artist-with-light-effect-v2';

interface RegisterSuccessProps {
    onClick?: () => void;
}
const RegisterSuccess: React.FC<RegisterSuccessProps> = ({onClick}) => {
    return (
        <div
            className={`w-full h-full relative overflow-hidden`}
            style={{
                background: '#031eff',
            }}>
            <div className="relative w-full max-w-[1200px] mx-auto flex flex-col justify-center items-center gap-[56px] py-11 md:py-[80px] xl:py-[120px]">
                <div className="w-full max-w-[1200px] flex flex-col justify-center gap-[56px] px-[15px] md:px-0">
                    <div className="flex xl:flex-row flex-col justify-start xl:items-start items-center">
                        <div className='mt-[40px]'>
                            <ArtistWithLightEffectV2 />
                        </div>
                        <div className="w-full max-w-[600px] flex flex-col h-full gap-2 mt-[56px] md:mt-[120px]">
                            <div className="w-full flex flex-col justify-center items-center">
                                {/* desktop ver */}
                                <div className='w-full md:flex justify-center items-center hidden'>
                                    <StrokeGradientText text="VUI LÒNG CHỜ XÁC NHẬN" fontSize={110} strokeWidth="8px" />
                                </div>
                                {/* mobile ver */}
                                <div className='w-full flex justify-center items-center md:hidden'>
                                    <StrokeGradientText text="VUI LÒNG CHỜ XÁC NHẬN" fontSize={78} strokeWidth="8px" />
                                </div>
                                <div className="w-full mt-[36px] mb-[56px] p-[2px] rounded-2xl border-[1px] border-white bg-transparent shadow-[0px_4px_20px_0px_rgba(0,0,0,0.25)]">
                                    <div className="font-montserrat w-full bg-white !bg-opacity-5 p-6 text-[18px] text-white text-justify">
                                        Cảm ơn bạn đã gửi thông tin vé tham gia{' '}
                                        <strong className="font-extrabold">"Vươn Concert"</strong> tại{' '}
                                        <strong className="font-extrabold">Festival Mẹ bầu &amp; Em bé 2025</strong> khu
                                        vực Hà Nội do KidsPlaza tổ chức. Thông tin chính thức về vé sẽ được gửi tới bạn qua Email/ Zalo ZNS sau khi hồ sơ được xét duyệt.
                                        <br />
                                        <br />
                                        Mọi thông tin cần hỗ trợ giải đáp xin vui lòng liên hệ{' '}
                                        <strong className="font-extrabold">
                                            hotline miễn phí của KidsPlaza theo số 1800.6608 - Nhánh số 3.
                                        </strong>
                                        <br />
                                        <br />
                                        Trân trọng cảm ơn!
                                    </div>
                                </div>
                                <CtaButton
                                    onClick={onClick}
                                    text="TRỞ VỀ TRANG CHỦ"
                                    contentClassName="px-6 py-[16px] text-[24px] font-bold"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterSuccess;
